import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAccordion } from '@angular/material/expansion';
import { MatTreeFlatDataSource } from '@angular/material/tree';

@Component({
  selector: 'app-search-group-field',
  templateUrl: './search-group-field.component.html',
  styleUrls: ['./search-group-field.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchGroupFieldComponent implements OnInit, OnDestroy {

  @Input() form!: FormControl;
  @Input() data!: any[];
  @Input() placeholder: string = '';
  @Input() treeControl: any;
  @Input() treeFlattener: any;
  @ViewChild(MatAccordion) expandTeam!: MatAccordion;
  @Output() selectedNode = new EventEmitter<any>();
  @Input() indicatorString: string | undefined = undefined;
  grpSelect: any = {};
  infoGrpList: any = {};
  panelOpenState = false;
  listenerFn = () => {};
  constructor(private renderer2: Renderer2, private ele: ElementRef) {
    this.listenerFn = this.renderer2.listen('window', 'click', (e: Event) => {
      if (
        (!this.ele.nativeElement.contains(e.target))
      ) { 
        this.expandTeam.closeAll();
      }
    });
  }
  ngOnDestroy(): void {
    // remove listener
    this.listenerFn();
  }

  ngOnInit(): void {
    this.infoGrpList = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    this.infoGrpList.data = this.data ? this.data : [];
  }

  hasChild = (_: number, node: any) => node.expandable;

  onGroupTeam(node: any) {
    if (this.grpSelect?.grpunit === node?.grpunit) {
      this.grpSelect = null
    } else {
      this.grpSelect = node;
    }
    this.selectedNode.emit(this.grpSelect);
  }

}
